var __WEBPACK_NAMESPACE_OBJECT__ = {"apiUrl":"https://api.anthroweekendutah.org"};